<template>
   <transition
    enter-from-class="opacity-0"
    enter-active-class="ease-out duration-100"
    enter-to-class="opacity-100"
    leave-from-class="opacity-100"
    leave-active-class="ease-in duration-100"
    leave-to-class="opacity-0"
  >
    <template v-if="state.show && !state.expired">
      <Link :href="route('cart')" class="block sticky z-10 bottom-0 left-0 w-full bg-gradient-to-r from-blue-500 to-purple-500">
        <div class="container pt-3 pb-2.5">
          <div class="flex justify-between items-center text-white">
            <div :href="route('cart')" class="flex items-center">
              <div class="relative pt-2 pr-3">
                <Icon type="cart" size="8" />
                <div class="absolute flex bg-gray-800 w-6 h-6 rounded-full top-0 right-0 leading-none">
                  <span class="m-auto font-semibold text-sm">{{ count }}</span>
                </div>
              </div>
              <span class="font-semibold text-sm uppercase ml-2">Ihr Warenkorb</span>
            </div>
            <transition
              enter-from-class="opacity-0"
              enter-active-class="ease-out duration-100"
              enter-to-class="opacity-100"
              leave-from-class="opacity-100"
              leave-active-class="ease-in duration-100"
              leave-to-class="opacity-0"
            >
              <div v-if="state.expires_in" class="font-semibold text-sm uppercase">
                <span class="hidden sm:inline">Reservierungszeit:</span>
                {{ state.expires_in }}
                <span class="sm:hidden">Minuten</span>
              </div>
            </transition>
          </div>
        </div>
      </Link>
    </template>
  </transition>
</template>

<script>
import Button from 'Web/Shared/Button.vue';
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';
import { usePage } from '@inertiajs/inertia-vue3';
import { computed, onMounted, onUnmounted, reactive, watchEffect } from 'vue';
import dayjs from 'dayjs';

export default {
  inheritAttrs: false,
  components: {
    Button,
    Icon,
    Link,
  },
  setup() {
    const state = reactive({
      expires_in: null,
      expired: null,
      show: null,
    });

    const cart = computed(() =>
      usePage().props.value.cart
    );

    function product(line) {
      return line.type === 'product';
    }

    function amount(acc, line) {
      return acc + line.amount;
    }

    const count = computed(() => {
      if (!cart.value)
        return 0;

      return cart.value.lines
        .filter(product)
        .reduce(amount, 0);
    });

    function update() {
      if (!cart.value?.expired_at)
        return state.expired = false;

      if (dayjs(cart.value.expired_at).isBefore()) {
        state.expires_in = null;
        state.expired = true;
        return;
      }

      const date = new Date(null);
      const diff = dayjs(cart.value.expired_at).unix() - dayjs().unix();

      date.setSeconds(diff);

      state.expires_in = date.toISOString().substr(14, 5);
      state.expired = false;
    }

    let interval;

    onMounted(() => {
      interval = setInterval(update, 1000);
      update();
    });

    onUnmounted(() => {
      clearInterval(interval);
    });

    watchEffect(() => {
      state.show = cart.value && count.value;
    });

    // watch(() => count.value, () => {
    //   // Make it pop
    // });

    return {
      cart,
      count,
      state,
    }
  }
}
</script>
